/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_CASH_BANK_DETAILS_SUCCESS,
  LOAD_CASH_BANK_DETAILS_ERROR,
  CREATE_CASH_BANK_DETAILS_SUCCESS,
  CREATE_CASH_BANK_DETAILS_ERROR,
  UPDATE_CASH_BANK_DETAILS_SUCCESS,
  UPDATE_CASH_BANK_DETAILS_ERROR,
  DELETE_CASH_BANK_DETAILS_SUCCESS,
  DELETE_CASH_BANK_DETAILS_ERROR,
  LOAD_CASH_BANK_TOTAL_LIST_SUCCESS,
  LOAD_CASH_BANK_TOTAL_LIST_ERROR,
  LOAD_TOTAL_CASH_BANK_TRANSACTION_SUCCESS,
  LOAD_TOTAL_CASH_BANK_TRANSACTION_ERROR,
  LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA_SUCCESS,
  LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA_ERROR,
  LOAD_CASH_IN_HAND_TRANSACTION_SUCCESS,
  LOAD_CASH_IN_HAND_TRANSACTION_ERROR,
  LOAD_ACCOUNT_TRANSACTION_DETAILS_SUCCESS,
  LOAD_ACCOUNT_TRANSACTION_DETAILS_ERROR,
  LOAD_CASH_IN_HAND_LIST_SUCCESS,
  LOAD_CASH_IN_HAND_LIST_ERROR,
} from "./constants";

const initialState = {
  cash_bank_details: [],
  cash_in_hand_details: [],
  cash_bank_total: [],
  total_cash_bank: [],
  account_transaction_list: [],
  cash_hand_list: [],
  record: {},
  records: {},
  recordsMetaData: {},
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    cash_bank_details,
    cash_bank_total,
    total_cash_bank,
    cash_in_hand_details,
    account_transaction_list,
    cash_hand_list,
    record,
    recordsMetaData = {},
    error,
    success,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_CASH_BANK_DETAILS_SUCCESS:
        draft.cash_bank_details = cash_bank_details;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_CASH_BANK_TOTAL_LIST_SUCCESS:
        draft.cash_bank_total = cash_bank_total;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_TOTAL_CASH_BANK_TRANSACTION_SUCCESS:
        draft.total_cash_bank = total_cash_bank;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_CASH_IN_HAND_TRANSACTION_SUCCESS:
        draft.cash_in_hand_details = cash_in_hand_details;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_ACCOUNT_TRANSACTION_DETAILS_SUCCESS:
        draft.account_transaction_list = account_transaction_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_CASH_IN_HAND_LIST_SUCCESS:
        draft.cash_hand_list = cash_hand_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_CASH_BANK_DETAILS_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case UPDATE_CASH_BANK_DETAILS_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.error = false;
        draft.success = success;
        break;
      case DELETE_CASH_BANK_DETAILS_SUCCESS:
        draft.record = record;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = recordsMetaData;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_CASH_BANK_DETAILS_ERROR:
      case CREATE_CASH_BANK_DETAILS_ERROR:
      case UPDATE_CASH_BANK_DETAILS_ERROR:
      case DELETE_CASH_BANK_DETAILS_ERROR:
      case LOAD_CASH_IN_HAND_LIST_ERROR:
      case LOAD_CASH_BANK_TOTAL_LIST_ERROR:
      case LOAD_CASH_IN_HAND_TRANSACTION_ERROR:
      case LOAD_TOTAL_CASH_BANK_TRANSACTION_ERROR:
      case LOAD_ACCOUNT_TRANSACTION_DETAILS_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.success = false;
        break;

      case LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
